import Vue from "vue"
import Vuex from 'vuex'

// 1.安装插件
Vue.use(Vuex)

// 2.创建对象
const store = new Vuex.Store({
    state:{
        commonParameters: {},

        baseColor: "#D32723",// 红包中心的基本色
        baseSecondColor: "#EB473E",// 红包中心背景色渐变的第二个颜色
        rebateTypeBgColor: "#FF6760",// 瓜分红包，等级红包标题的背景色
        exchangeSelectedStartColor: "#FF9063",// 兑换选择额度的选项选中状态颜色值之一
        exchangeSelectedEndColor: "#FF3948",// 兑换选择额度的选项选中状态颜色值之一
        openRebateUI1: false,// 是不是需要替换成RebateUI1的红包资源

        
        payCenterPageWidth: "85vw",// 20 X 16px = 320px
        payCenterPageHeight: "30vh",// 12.5 X 16px = 200px

        
        titleFontSize:"1.125rem",// 18px
        inputFontSize:"0.75rem",// 12px
        buttonSize:"0.75rem",// 12px

        payPageTitleColor:"#5A5A5A",

        // 显示微信绑定授权二维码界面，因为在多个页面都可能显示，就放在最外层，可随时打开
        showWxBindPage: false,
        qrCodeUrl: "",
        // 显示加载中动画
        showLoading: false,
        // 显示提示窗口
        showAlert: false,
        alertMessage: "提示窗口文字",
        
        // 显示toast
        showToast: false,
        toastMessage: "toast文字",

        // 未读消息条数
        unreadMessages: 0,

        // 兑换列表显示类型，是瓜分红包(1)还是等级红包(2)
        exchangeType: 1,
        // 红包初始化返回
        initData: {
            content: "",
            money: "0",
            rebateType: [],
            rebateDivide: "0",
            rebateExchange: "",// 等级红包兑换额度列表数据
            rebateExchangeDivide: "",
            rebateExchangeLogin: "",// 登录红包兑换额度列表数据
            holidayMember: "",
            receiveTotal: "",
            bonusPool: "",// 奖金池总金额
            // content: "这次活动的目的呢是为了给广大玩家发福利xxxxxxxxxxx",
            // money: "99998.00",
            // rebateType: "[{\"typeid\":1,\"typename\":\"等级红包\"}]",
            // rebateDivide: "1",
            // rebateExchange: "[{\"exchangeMoney\":5},{\"exchangeMoney\":10},{\"exchangeMoney\":20},{\"exchangeMoney\":100}]",
            // rebateExchangeDivide: "[{\"exchangeMoney\":10},{\"exchangeMoney\":20}]",
            // holidayMember: "923671",
            // receiveTotal: "100000",
        },
        // 红包用户接口返回
        userInfoData:{
            money: "0",
            loginmoney: "0",
            dividemoney: "0",
            totalmoney: "0",
            aliuser: "0",
            wxuser: "0",
            mobile: "0",
            timeout: "0",
            exchangefirst: "",// 首次兑换的目前只有瓜分红包
            exchangefirstmoney: "",
            exchangeadd: [],// 新增兑换额度的目前只有等级红包
            changelevel: "",
            // money: "10.98",
            // loginmoney: "0.98",
            // dividemoney: "9.98",
            // totalmoney: "99990.00",
            // aliuser: "0",
            // wxuser: "0",
            // mobile: "0",
            // timeout: "86401",
            // exchangefirst: "1",// 首次兑换的目前只有瓜分红包
            // exchangefirstmoney: "1.00",
            // exchangeadd: ['3','100','500'],// 新增兑换额度的目前只有等级红包
            // changelevel: "1000",
        },
        // 红包V2,需要打开哪个红包的兑换页面，0：等级   1：登录
        cashoutTypeV2: 0,
        // 红包V2用户接口返回
        userInfoV2Data:{
            money: "0",
            loginmoney: "0",
            dividemoney: "0",
            totalmoney: "0",
            aliuser: "0",
            wxuser: "0",
            mobile: "0",
            timeout: "0",// 活动倒计时
            dayconsecutive:"",// 连续登录天数，单位：天
            daycount: "", // 累计登录天数，单位：天
            exchangefirst: "",// 等级红包是否有首次兑换
            exchangefirstmoney: "",// 等级红包首次兑换数组
            // divideexchangefirst: "",// 瓜分红包是否有首次兑换
            // divideexchangefirstmoney: "",// 瓜分红包首次兑换数组
            loginexchangefirst: "",// 登录红包是否有首次兑换
            loginexchangefirstmoney: "",// 登录红包首次兑换数组
            exchangeadd: "",// 新增兑换额度的目前只有等级红包
            changelevel: "",
        },
        // 角色数据
        roleInfoData:{
            roleId: "",
            roleName: "",
            serverId: "",
            serverName: "",
            level: ""
            // roleId: "123456",
            // roleName: "测试角色名",
            // serverId: "9527",
            // serverName: "测试区服名",
            // level: "20"
        },
        // 瓜分红包数组
        divideListData:[],
        
        // divideListData:{
        //     rebateList: "[{\"confid\":1,\"typeid\":1,\"rebateamount\":0.99,\"rebatename\":\"1级红包\",\"rebatedesc\":\"玩游戏就送红包\",\"status\":2},{\"confid\":2,\"typeid\":1,\"rebateamount\":3.99,\"rebatename\":\"5级红包\",\"rebatedesc\":\"十天内达到5级送红包\",\"status\":1},{\"confid\":3,\"typeid\":1,\"rebateamount\":5.99,\"rebatename\":\"50级红包\",\"rebatedesc\":\"十天内达到50级送红包\",\"status\":0}]",
        // },
        // 等级红包数组
        levelRebateListData:[],
        // levelRebateListData:{
        //     rebateList:"[{\"confid\":1,\"typeid\":1,\"rebateamount\":199,\"rebatename\":\"1级红包\",\"rebatedesc\":\"玩游戏就送红包\",\"status\":2},{\"confid\":2,\"typeid\":1,\"rebateamount\":3.99,\"rebatename\":\"5级红包\",\"rebatedesc\":\"十天内达到5级送红包\",\"status\":1},{\"confid\":3,\"typeid\":1,\"rebateamount\":5.99,\"rebatename\":\"50级红包\",\"rebatedesc\":\"十天内达到50级送红包\",\"status\":0},{\"confid\":1,\"typeid\":1,\"rebateamount\":10.99,\"rebatename\":\"1级红包\",\"rebatedesc\":\"玩游戏就送红包\",\"status\":2},{\"confid\":2,\"typeid\":1,\"rebateamount\":3.99,\"rebatename\":\"5级红包\",\"rebatedesc\":\"十天内达到5级送红包\",\"status\":1},{\"confid\":3,\"typeid\":1,\"rebateamount\":5.99,\"rebatename\":\"50级红包\",\"rebatedesc\":\"十天内达到50级送红包\",\"status\":0},{\"confid\":1,\"typeid\":1,\"rebateamount\":100.99,\"rebatename\":\"1级红包\",\"rebatedesc\":\"玩游戏就送红包\",\"status\":2},{\"confid\":2,\"typeid\":1,\"rebateamount\":3.99,\"rebatename\":\"5级红包\",\"rebatedesc\":\"十天内达到5级送红包\",\"status\":1},{\"confid\":3,\"typeid\":1,\"rebateamount\":5.99,\"rebatename\":\"50级红包\",\"rebatedesc\":\"十天内达到50级送红包\",\"status\":0},{\"confid\":1,\"typeid\":1,\"rebateamount\":0.99,\"rebatename\":\"1级红包\",\"rebatedesc\":\"玩游戏就送红包\",\"status\":2},{\"confid\":2,\"typeid\":1,\"rebateamount\":3.99,\"rebatename\":\"5级红包\",\"rebatedesc\":\"十天内达到5级送红包\",\"status\":1},{\"confid\":3,\"typeid\":1,\"rebateamount\":5.99,\"rebatename\":\"50级红包\",\"rebatedesc\":\"十天内达到50级送红包\",\"status\":0},{\"confid\":1,\"typeid\":1,\"rebateamount\":0.99,\"rebatename\":\"1级红包\",\"rebatedesc\":\"玩游戏就送红包\",\"status\":2},{\"confid\":2,\"typeid\":1,\"rebateamount\":3.99,\"rebatename\":\"5级红包\",\"rebatedesc\":\"十天内达到5级送红包\",\"status\":1},{\"confid\":3,\"typeid\":1,\"rebateamount\":5.99,\"rebatename\":\"50级红包\",\"rebatedesc\":\"十天内达到50级送红包\",\"status\":0},{\"confid\":1,\"typeid\":1,\"rebateamount\":0.99,\"rebatename\":\"1级红包\",\"rebatedesc\":\"玩游戏就送红包\",\"status\":2},{\"confid\":2,\"typeid\":1,\"rebateamount\":3.99,\"rebatename\":\"5级红包\",\"rebatedesc\":\"十天内达到5级送红包\",\"status\":1},{\"confid\":3,\"typeid\":1,\"rebateamount\":5.99,\"rebatename\":\"50级红包\",\"rebatedesc\":\"十天内达到50级送红包\",\"status\":0},{\"confid\":1,\"typeid\":1,\"rebateamount\":0.99,\"rebatename\":\"1级红包\",\"rebatedesc\":\"玩游戏就送红包\",\"status\":2},{\"confid\":2,\"typeid\":1,\"rebateamount\":3.99,\"rebatename\":\"5级红包\",\"rebatedesc\":\"十天内达到5级送红包\",\"status\":1},{\"confid\":3,\"typeid\":1,\"rebateamount\":5.99,\"rebatename\":\"50级红包\",\"rebatedesc\":\"十天内达到50级送红包\",\"status\":0}]",
        // },
        // 兑换数组
        exchangeLogs: [{"datetime":"2023-01-01","amount": "10"},{"datetime":"2023-01-01","amount": "10"},{"datetime":"2023-01-01","amount": "10"},{"datetime":"2023-01-01","amount": "10"},{"datetime":"2023-01-01","amount": "10"},{"datetime":"2023-01-01","amount": "10"},{"datetime":"2023-01-01","amount": "10"},{"datetime":"2023-01-01","amount": "10"},{"datetime":"2023-01-01","amount": "10"},{"datetime":"2023-01-01","amount": "10"},{"datetime":"2023-01-01","amount": "10"},{"datetime":"2023-01-01","amount": "10"},{"datetime":"2023-01-01","amount": "10"},{"datetime":"2023-01-01","amount": "10"},{"datetime":"2023-01-01","amount": "10"},{"datetime":"2023-01-02","amount": "1000"},],
    },
    mutations:{
        // 接收客户端传来的数据，并将角色数据赋值给 roleInfoData 
        updateCommonParams(state, payload){
            // console.log(payload)
            state.commonParameters = JSON.parse(payload)
            state.roleInfoData.roleId = state.commonParameters["roleid"];
            state.roleInfoData.roleName = state.commonParameters["rolename"];
            state.roleInfoData.serverId = state.commonParameters["serverid"];
            state.roleInfoData.serverName = state.commonParameters["servername"];
            state.roleInfoData.level = state.commonParameters["rolelevel"];
            // Vue.set(state.commonParameters, JSON.parse(payload))
        },
        UpdateRidAndPhone(state, payload){
            state.commonParameters["rid"] = payload["rid"];
            state.commonParameters["phone"] = payload["phone"];
        },
        // 网络请求到红包初始化数据之后重新赋值
        updateInitData(state,payload){
            // console.log("红包初始化")
            // console.log(payload)
            state.initData = payload
            // console.log("红包初始化后获得的 rebateType");
            // console.log(state.initData['rebateType']);
            state.initData['rebateType'] = JSON.parse(state.initData['rebateType']);
        },
        // 网络请求到红包用户信息数据之后重新赋值
        updateRebateUserInfoData(state,payload){
            // console.log("红包用户信息")
            // console.log(payload)
            state.userInfoData = payload
        },
        // 网络请求到V2红包用户信息数据之后重新赋值
        updateRebateUserInfoDataV2(state,payload){
            // console.log("红包用户信息")
            // console.log(payload)
            state.userInfoV2Data = payload
        },
        //用户信息接口，根据用户名去获取phone,rid值的
        updateInfoData(state,payload){
            // console.log("用户信息")
            // console.log(payload)
            state.commonParameters['rid'] = payload['rid']
            state.commonParameters['phone'] = payload['phone']
        },
        // 网络请求到瓜分红包数组数据之后重新赋值
        updateDivideListData(state,payload){
            let rebateList = JSON.parse(payload["rebateList"]);
            state.divideListData = rebateList
        },
        // 网络请求到等级红包数组数据之后重新赋值
        updateLevelRebateListData(state,payload){
            let rebateList = JSON.parse(payload["rebateList"]);
            state.levelRebateListData = rebateList
        },
        // 改变微信绑定二维码界面显示状态
        showWxBindPageState(state, showOrHide){
            state.showWxBindPage = showOrHide;
        },
        // 打开兑换页面  兑换列表显示类型，是瓜分红包(1)还是等级红包(2)
        openCashOutPage(state, exchangeType){
            state.exchangeType = exchangeType;
            state.showCashOutPage = true;
            // console.log("打开兑换页面");
        },
        // 切换加载中动画
        switchLoading(state, showOrHide){
            state.showLoading = showOrHide;
        },
        // 切换提示窗口
        switchAlert(state, payload){
            state.showAlert = payload["showOrHide"];
            state.alertMessage = payload["alertMessage"];
        },
        // 切换toast
        switchToast(state, payload){
            state.showToast = payload["showOrHide"];
            state.toastMessage = payload["toastMessage"];
        },
        // 领取红包之后，修改兑换余额，并且修改红包显示列表的状态
        changeExchangeMoneyAndRebateShowList(state, payload){
            // {
                //     "money": "28.00",
                //     "dividemoney": "10.00",
                //     "totalmoney": "1228.00",
                //     "rebatedesc": "打开获得了1228.00元",
                //     "index": 0,
                //     "type": "level"
                // }
            if("level" === payload["type"]){
                // 等级红包领取
                state.userInfoData.money = payload["money"];
                let index = payload["index"];

                let successItem = state.levelRebateListData[index];
                successItem["status"] = 2;
                successItem["rebatedesc"] = payload["rebatedesc"];
                // 先把已成功领取的移除
                state.levelRebateListData.splice(index, 1);
                // 再添加在最后面
                state.levelRebateListData.push(successItem)
                
            }else{
                // 瓜分红包领取
                state.userInfoData.dividemoney = payload["dividemoney"];
                let index = payload["index"];

                let successItem = state.divideListData[index];
                successItem["status"] = 2;
                successItem["rebatedesc"] = payload["rebatedesc"];
            }

        },
        // 兑换成功之后，更新瓜分和等级红包的剩余可兑换金额
        changeDivideAndLevelMoney(state, payload){
            state.userInfoData.money = payload["money"];
            state.userInfoData.dividemoney = payload["dividemoney"];
        },
        // 兑换成功之后，更新瓜分和等级红包的剩余可兑换金额
        changeDivideAndLevelMoneyV2(state, payload){
            state.userInfoV2Data.money = payload["money"];
            state.userInfoV2Data.dividemoney = payload["dividemoney"];
        },
        // 更新未读信息
        updateUnreadMessages(state, payload){
            state.unreadMessages = payload;
        },
        // 修改要显示的Qrcode
        changeQrcodeUrl(state, payload){
            state.qrCodeUrl = payload;
        },
        // 兑换列表数据
        updateExchangeLogList(state, payload){
            state.exchangeLogs = payload;
        },
        // 更新当前选择的红包版本v2的兑换类型
        updateCashoutTypeV2(state,payload){
            state.cashoutTypeV2 = payload;
        },
        //红包V2，领取完红包之后，更新对应的红包数据，以及所有页面需要显示的数据更新
        updateV2MoneyAndRebateShowList(state, payload){
            // 领取完直接在领取的页面中重新获取数据，不在这里刷新
            // 更新奖金池
            state.initData.bonusPool = payload["bonuspool"];
            // 等级红包领取
            state.userInfoV2Data.money = payload["money"];
            // 等级红包领取
            state.userInfoV2Data.loginmoney = payload["loginmoney"];
        },
        // 更新红包中心的背景色
        updateBaseColorAndSecondColor(state, payload){
            state.baseColor = payload['baseColor'];
            state.baseSecondColor = payload['baseSecondColor'];
        },
        // 是否开启的是 RebateUI1 的红包资源
        updateRebateUI1Open(state, payload){
            state.openRebateUI1 = payload;
            state.rebateTypeBgColor = "#FF5273";
            state.exchangeSelectedStartColor = "#FF849C"// 兑换选择额度的选项选中状态颜色值之一
            state.exchangeSelectedEndColor = "#FF5273"// 兑换选择额度的选项选中状态颜色值之一
        },
        // 更新登录界面的宽高
        updateLoginPageSize(state, payload){
            state.payCenterPageWidth = "45vw";
            state.payCenterPageHeight = "55vh";
        },
        // 更新登录界面的宽高
        updateLoginPageSizeWithValue(state, payload){
            if (payload['screenWidth']) {
                state.payCenterPageWidth = payload['screenWidth'];
            }
            if (payload['screenHeight']) {
                state.payCenterPageHeight = payload['screenHeight'];
            }
        }
        
    },
    actions:{
        // 获取rid和phone后，更新到基本参数中
        networkUpdateRid(context, payload){
            context.commit('UpdateRidAndPhone', payload);
        }
        ,
        // 异步获取瓜分，等级红包列表后，更新数据
        networkHandleRebateList(context, payload){
            context.commit('updateDivideListData', payload.divideListData);
            context.commit('updateLevelRebateListData', payload.levelRebateListData);
        },
        // 异步获取红包初始化，用户信息后，更新数据
        networkHandleRebateAndUserInit(context, payload){
            context.commit('updateInitData', payload.initData);
            context.commit('updateRebateUserInfoData', payload.userInfoData);
        },
        
        // 异步获取红包V2初始化，用户信息后，更新数据
        networkHandleRebateAndUserInitV2(context, payload){
            context.commit('updateInitData', payload.initData);
            context.commit('updateRebateUserInfoDataV2', payload.userInfoData);
        },
        // 异步领取红包之后，去更新数据
        networkLevelRebateRecevice(context, payload){
            context.commit('changeExchangeMoneyAndRebateShowList', payload);
        },
        // 兑换之后，去更新数据
        networkExchange(context, payload){
            context.commit('changeDivideAndLevelMoney', payload);
        },
        // 网络请求后，需要隐藏微信绑定二维码显示页面
        networkWxBindPageShow(context, payload){
            context.commit("changeQrcodeUrl", payload['qrcodeUrl']);
            context.commit("showWxBindPageState", payload['showOrHide']);
        },
        // 更新兑换列表数据
        networkExchangeLogList(context, payload){
            context.commit("updateExchangeLogList", payload);
        },
        // 红包V2，领取红包之后，去更新数据
        networkV2RebateRecevice(context, payload){
            context.commit('updateV2MoneyAndRebateShowList', payload);
        },
        // 兑换之后，去更新数据
        networkExchangeV2(context, payload){
            context.commit('changeDivideAndLevelMoneyV2', payload);
        },
    },
    getters:{
        // 获取基本参数
        getCommomParams(state){
            return state.commonParameters
        },
        // 获取等级红包兑换列表数据
        getLevelExchangeList(state){
            let needArray = []
            let rebateExchangeList = JSON.parse(state.initData.rebateExchange)
            // 解析原有的等级红包兑换额度
            for (let index = 0; index < rebateExchangeList.length; index++) {
                const element = rebateExchangeList[index];
                const exchangeValue = element['exchangeMoney']
                needArray.push(exchangeValue)
            }
            // 解析额外添加的兑换额度
            let exchangeadd = state.userInfoData.exchangeadd
            for (let index = 0; index < exchangeadd.length; index++) {
                const addExchangeValue = parseInt(exchangeadd[index]);
                // NAN 的话 ，自身是不相等的
                if (addExchangeValue == addExchangeValue) {
                    if (!needArray.includes(addExchangeValue)) { 
                        needArray.push(addExchangeValue);
                    }
                }
            }
            // 数字数组升序，降序的话就将后面的 a, b 相减倒转一下
            needArray.sort(function(a, b){return a - b});
            return needArray;
        },
        // 获取红包V2版本等级红包兑换列表数据
        getV2LevelExchangeList(state){
            let needArray = []
            let rebateExchangeList = JSON.parse(state.initData.rebateExchange)
            // 解析原有的等级红包兑换额度
            for (let index = 0; index < rebateExchangeList.length; index++) {
                const element = rebateExchangeList[index];
                // 固定显示的兑换额度，不需要显示剩余次数
                element['showLeftOver'] = false;
                needArray.push(element)
            }
            // 判断等级红包是否需要添加新的兑换额度
            let exchangefirst = state.userInfoV2Data.exchangefirst;
            if ("1" === exchangefirst) {
                // 解析额外添加的兑换额度
                let levelExchangeList = JSON.parse(state.userInfoV2Data.exchangefirstmoney)
                for (let index = 0; index < levelExchangeList.length; index++) {
                    const element = levelExchangeList[index];
                    // 判断兑换额度是否已经存在，存在则不新增
                    let exchangeMoney = element['exchangeMoney'];
                    let needAddToArray = true;
                    for (let i = 0; i < needArray.length; i++) {
                        const e2 = needArray[i];
                        if (exchangeMoney === e2['exchangeMoney']) {
                            needAddToArray = false;
                            break;
                        }
                    }
                    if (needAddToArray) {
                        // 额外新增的兑换额度，需要显示剩余次数
                        if (element['status'] == '1') {
                            element['showLeftOver'] = true;
                        }else{
                            element['showLeftOver'] = false;
                        }
                        needArray.push(element)
                    }
                }
            }
            // 数字数组升序，降序的话就将后面的 a, b 相减倒转一下
            needArray.sort(function(a, b){return a - b});
            return needArray;
        },
        getV2LoginExchangeList(state){
            // rebateExchangeLogin
            let needArray = []
            let loginExchangeList = JSON.parse(state.initData.rebateExchangeLogin)
            // 解析原有的等级红包兑换额度
            for (let index = 0; index < loginExchangeList.length; index++) {
                const element = loginExchangeList[index];
                // 固定显示的兑换额度，不需要显示剩余次数
                element['showLeftOver'] = false;
                needArray.push(element)
            }
            // 判断登录红包是否需要添加新的兑换额度
            let loginexchangefirst = state.userInfoV2Data.loginexchangefirst;
            if ("1" === loginexchangefirst) {
                // 解析额外添加的兑换额度
                let loginExchangeList = JSON.parse(state.userInfoV2Data.loginexchangefirstmoney)
                for (let index = 0; index < loginExchangeList.length; index++) {
                    const element = loginExchangeList[index];
                    // 判断兑换额度是否已经存在，存在则不新增
                    let exchangeMoney = element['exchangeMoney'];
                    let needAddToArray = true;
                    for (let i = 0; i < needArray.length; i++) {
                        const e2 = needArray[i];
                        if (exchangeMoney === e2['exchangeMoney']) {
                            needAddToArray = false;
                            break;
                        }
                    }
                    if (needAddToArray) {
                        // 额外新增的兑换额度，需要显示剩余次数
                        if (element['status'] == '1') {
                            element['showLeftOver'] = true;
                        }else{
                            element['showLeftOver'] = false;
                        }
                        needArray.push(element)
                    }
                }
            }
            // 数字数组升序，降序的话就将后面的 a, b 相减倒转一下
            needArray.sort(function(a, b){return a - b});
            return needArray;
        },
        // 获取瓜分红包兑换列表数据
        getDivideExchangeList(state){
            let needArray = []
            let rebateExchangeList = JSON.parse(state.initData.rebateExchangeDivide)
            // 解析原有的等级红包兑换额度
            for (let index = 0; index < rebateExchangeList.length; index++) {
                const element = rebateExchangeList[index];
                // const exchangeValue = element['exchangeMoney']
                element["isFirst"] = false;
                needArray.push(element)
            }
            // 首次兑换
            if ("1" === state.userInfoData.exchangefirst) {
                let firstExchangeMoney = parseInt(state.userInfoData.exchangefirstmoney)
                // NAN 的话 ，自身是不相等的
                if (firstExchangeMoney == firstExchangeMoney) {
                    let firstExchangeDic = {"exchangeMoney": firstExchangeMoney, "isFirst": true};
                    needArray.push(firstExchangeDic)
                }
            }
            // 数字数组升序，降序的话就将后面的 a, b 相减倒转一下
            needArray.sort(function(a, b){return a["exchangeMoney"] - b["exchangeMoney"]});
            return needArray;
        }

    },
    modules:{
        
    }
})

// 3.导出
export default store


// WEBPACK FOOTER //
// ./src/store/index.js